import { mapGetters } from 'vuex';
import * as moment from 'moment';
import api from '@/utils/api';
import JWTHelper from '@/jwt-token';
import LoadingComponent from '@/components/loading-component';
import * as Constants from '@/constants';

export default {
  name: 'SelectStudent',
  components: {
    LoadingComponent
  },
  computed: {
    ...mapGetters({
      showTooltip: 'showTooltip'
    }),
    filteredStudents() {
      // make a copy of the students array
      let students = this.studentsArray.slice();
      // if allSupportsToggle is false (not toggled),
      // only show end dates that are current
      if (!this.allSupportsToggle) {
        students = students.filter((student) => {
          return moment(student.endDate, 'YYYY-MM-DD') > moment();
        });
      }

      // if text is entered in the find student input,
      // filter the list of students based on the input
      if (this.findStudentSearch) {
        students = students.filter((student) => {
          // if search is not a number, search start of first or last name
          if (isNaN(this.findStudentSearch)) {
            const regex = new RegExp(`^${this.findStudentSearch}`, 'i');
            const [lastName, firstName] = student.studentName.split(',');
            return regex.test(firstName.trim()) || regex.test(lastName.trim());
          }
          const regex = new RegExp(`^${this.findStudentSearch}`);
          return regex.test(student.studentExtId);
        });
      }

      // if location search, filter based on school
      if (this.findSchoolSearch) {
        students = students.filter((student) => {
          const regex = new RegExp(`^${this.findSchoolSearch}`, 'i');
          return regex.test(student.schoolName);
        });
      }

      if (this.checkAllBoxes) {
        students = students.map((student) => {
          return {
            ...student,
            selected: this.checkAllBoxes
          };
        });
      }

      return students;
    },
    isMobile() {
      return this.$mq === 'mobile';
    }
  },
  data() {
    return {
      dialog: false,
      allSupportsToggle: false,
      checkAllBoxes: false,
      nameSortAsc: false,
      findStudentSearch: '',
      locationSearch: null,
      errMsg: '',
      sort: '',
      selectAll: false,
      isAgencyUser: false,
      selectedProvider: null,
      showSelectStudents: false,
      sheet: false,
      locationsArray: [],
      timeout: null,
      searchInput: null,
      locationsLoading: false,
      // provider autocomplete
      providerSearchError: '',
      providerSearchInput: null,
      providerSearchLoading: false,
      providersArray: [],
      // find student autocomplete
      studentSearchError: '',
      studentSearchInput: null,
      studentSearchLoading: false,
      studentsArray: [],
      isAgency: null,
      providerId: null,
      showLoading: false,
      findSchoolSearch: ''
    };
  },
  created() {
    this.isAgency = JWTHelper.isProxy() || JWTHelper.isAdmin();
    // set providerId if it exists in local storage
    this.providerId = localStorage.getItem('provider-id') || null;
    // if they are not an agency, they will only have the option of selecting students
    // get students for non agency users
    if (!this.isAgency) {
      this.getStudentList('lastNameAsc');
    }
  },
  methods: {
    clearProvidersAutoComplete() {
      if (!this.selectedProvider) {
        this.providersArray = [];
      }
    },
    onNextClicked() {
      const selectedStudents = this.filteredStudents.filter((student) => {
        return student.selected;
      });
      if (selectedStudents.length) {
        let idString = '';
        for (let i = 0, l = selectedStudents.length; i < l; i++) {
          idString += selectedStudents[i].serviceId;
          // if the counter is less than the array length
          // and the array length is longer than one
          // add a comma
          if (i < l - 1 && l > 1) {
            idString += ',';
          }
        }
        localStorage.setItem('selected-students', idString);
        this.$router.push('/create');
      } else {
        this.errMsg = 'Please select students.';
      }
    },
    getStudentList(searchParam) {
      this.showLoading = true;
      api.get(Constants.NSL_PROVIDERS_STUDENT_SERVICES_LIST_URL(this.providerId, searchParam))
        .then((res) => {
          // flatten the nested arrays
          this.studentsArray = res.data.data;
          this.showSelectStudents = true;
          this.showLoading = false;
        });
    },
    goToSelectStudents() {
      // set the providerId on localStorage
      if (this.selectedProvider) {
        // set the proivderId locally to use in filtering schools
        this.providerId = this.selectedProvider.userId;
        // assign providerId to localstorage
        localStorage.setItem('provider-id', this.selectedProvider.userId.toString());
        this.getStudentList('lastNameAsc');
        // clear the selected provider
        this.selectedProvider = '';
      }
    },
    clearParameters() {
      this.selectedProvider = '';
      this.findStudentSearch = '';
      this.findSchoolSearch = '';
      this.allSupportsToggle = false;
      this.errMsg = '';
    },
    returnToProviders() {
      this.clearParameters();
      this.showSelectStudents = false;
    }
  },
  watch: {
    dialog() {
      // dialog will be true when opening the dialog, clear out values
      if (this.dialog) {
        this.errorMsg = null;
        this.showSelectStudents = false;
        this.sheet = true;
        // reorder the student list by lastNameAsc
        if (!this.isAgency) this.getStudentList('lastNameAsc');
      } else {
        this.clearParameters();
      }
    },
    providerSearchInput() {
      // show loading
      this.providerSearchLoading = true;
      // clear timeout if function is called before setTimeout fires
      clearTimeout(this.timeout);
      // make sure the user types something before firing request
      if (this.providerSearchInput) {
        // fire the request after a delay
        this.timeout = setTimeout(() => {
          api.get(Constants.NSL_GET_ACTIVE_PROVIDER_LIST_URL(this.providerSearchInput))
            .then((res) => {
              this.providersArray = res.data.data;
            })
            .catch((error) => {
              this.providerSearchError = error.message;
            })
            .finally(() => {
              // stop loading
              this.providerSearchLoading = false;
            });
        }, 300);
      } else {
        this.providerSearchLoading = false;
      }
    },
    // watcher on sort dropdown
    sort() {
      this.getStudentList(this.sort);
    },
    selectedProvider(newVal, oldVal) {
      if (!newVal && oldVal) this.providersArray = [];
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/select-student-dialog/select-student-dialog.js